export default {
    normal: '20px',
    large: '30px',
    xlarge: '60px',
    normalSm: '20px',
    largeSm: '30px',
    xlargeSm: '40px',
    xxlargeSm: '60px'
};
